import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '功能用例',
    type: 'BDLOGIC_UI',
}
